//events.js
import request from '@/utils/request';

export function getEvents(params) {
  return request({
    url: '/v1/forum_info/basic',
    method: 'get',
    params: params,
  });
}

export function getMyEvents(params) {
  return request({
    url: '/v1/user_info/participated_forum',
    method: 'get',
    params: params,
  });
}
